/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_No_Chart_DataInputs */



/**
* | output |
* | --- |
* | "No data available for the selected period" |
*
* @param {Usage_No_Chart_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_no_chart_data = /** @type {((inputs?: Usage_No_Chart_DataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_No_Chart_DataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune donnée disponible pour la période sélectionnée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für den ausgewählten Zeitraum sind keine Daten verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun dato disponibile per il periodo selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Данные за выбранный период отсутствуют.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay datos disponibles para el período seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选时间段内无可用数据。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択した期間のデータはありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित अवधि के लिए कोई डेटा उपलब्ध नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há dados disponíveis para o período selecionado.")
	return /** @type {LocalizedString} */ ("No data available for the selected period")
});